var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-search-dropdown-component" }, [
    _vm.getResultLength > 0 || _vm.top5Projects.length > 0
      ? _c(
          "div",
          {
            staticClass:
              "search-dropdown-content search-section-title-container"
          },
          [
            _vm.$store.getters.getGlobalSearchResult("projectsByText").length >
            0
              ? _c(
                  "h3",
                  {
                    staticClass:
                      "remove-margin search-section-title selected-section",
                    on: {
                      click: function($event) {
                        _vm.openResultSection(
                          _vm.$t("globalSearchSections.stories"),
                          $event
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("globalSearchSections.stories")) + " "
                    )
                  ]
                )
              : _vm._e(),
            _vm.$store.getters.getGlobalSearchResult("projectsByTool").length >
            0
              ? _c(
                  "h3",
                  {
                    class: [
                      "remove-margin",
                      "search-section-title",
                      {
                        "selected-section":
                          _vm.$store.getters.isFieldSelected(
                            "projectsByTool"
                          ) ||
                          _vm.$store.getters.getGlobalSearchResult(
                            "projectsByText"
                          ).length === 0
                      }
                    ],
                    on: {
                      click: function($event) {
                        _vm.openResultSection(
                          _vm.$t("globalSearchSections.tools"),
                          $event
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("globalSearchSections.tools")) + " "
                    )
                  ]
                )
              : _vm._e(),
            _vm.$store.getters.getGlobalSearchResult("projectsByCertification")
              .length > 0
              ? _c(
                  "h3",
                  {
                    class: [
                      "remove-margin",
                      "search-section-title",
                      {
                        "selected-section": _vm.$store.getters.isFieldSelected(
                          "projectsByCertification"
                        )
                      }
                    ],
                    on: {
                      click: function($event) {
                        _vm.openResultSection(
                          _vm.$t("globalSearchSections.certifications"),
                          $event
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("globalSearchSections.certifications")) +
                        " "
                    )
                  ]
                )
              : _vm._e(),
            !_vm.$store.getters.getGlobalSearchResult("showResults")
              ? _c(
                  "h3",
                  {
                    class: [
                      "remove-margin",
                      "search-section-title",
                      "selected-section",
                      "normal-cursor"
                    ]
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("globalSearchSections.top5Projects")) +
                        " "
                    )
                  ]
                )
              : _vm._e(),
            _vm.$store.getters.getGlobalSearchResult("projectsByCompany")
              .length > 0
              ? _c(
                  "h3",
                  {
                    class: [
                      "remove-margin",
                      "search-section-title",
                      {
                        "selected-section": _vm.$store.getters.isFieldSelected(
                          "projectsByCompany"
                        )
                      }
                    ],
                    on: {
                      click: function($event) {
                        _vm.openResultSection(
                          _vm.$t("globalSearchSections.companies"),
                          $event
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("globalSearchSections.companies")) +
                        " "
                    )
                  ]
                )
              : _vm._e(),
            _vm.$store.getters.getGlobalSearchResult("projectsByOwner").length >
            0
              ? _c(
                  "h3",
                  {
                    class: [
                      "remove-margin",
                      "search-section-title",
                      {
                        "selected-section":
                          _vm.$store.getters.isFieldSelected(
                            "projectsByOwner"
                          ) ||
                          _vm.$store.getters.getGlobalSearchResult(
                            "projectsByOwner"
                          ).length === 0
                      }
                    ],
                    on: {
                      click: function($event) {
                        _vm.openResultSection(
                          _vm.$t("globalSearchSections.referenceOwners"),
                          $event
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("globalSearchSections.referenceOwners")) +
                        " "
                    )
                  ]
                )
              : _vm._e(),
            _vm.$store.getters.getGlobalSearchResult(
              "projectsByBusinessContactManager"
            ).length > 0
              ? _c(
                  "h3",
                  {
                    class: [
                      "remove-margin",
                      "search-section-title",
                      {
                        "selected-section":
                          _vm.$store.getters.isFieldSelected(
                            "projectsByBusinessContactManager"
                          ) ||
                          _vm.$store.getters.getGlobalSearchResult(
                            "projectsByBusinessContactManager"
                          ).length === 0
                      }
                    ],
                    on: {
                      click: function($event) {
                        _vm.openResultSection(
                          _vm.$t(
                            "globalSearchSections.businessContactManagers"
                          ),
                          $event
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("globalSearchSections.businessContactManagers")
                        ) +
                        " "
                    )
                  ]
                )
              : _vm._e(),
            _vm.$store.getters.getGlobalSearchResult(
              "projectsByDeliveryContactManager"
            ).length > 0
              ? _c(
                  "h3",
                  {
                    class: [
                      "remove-margin",
                      "search-section-title",
                      {
                        "selected-section":
                          _vm.$store.getters.isFieldSelected(
                            "projectsByDeliveryContactManager"
                          ) ||
                          _vm.$store.getters.getGlobalSearchResult(
                            "projectsByDeliveryContactManager"
                          ).length === 0
                      }
                    ],
                    on: {
                      click: function($event) {
                        _vm.openResultSection(
                          _vm.$t(
                            "globalSearchSections.deliveryContactManagers"
                          ),
                          $event
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("globalSearchSections.deliveryContactManagers")
                        ) +
                        " "
                    )
                  ]
                )
              : _vm._e(),
            _vm.$store.getters.getGlobalSearchResult("offers").length > 0
              ? _c(
                  "h3",
                  {
                    class: [
                      "remove-margin",
                      "search-section-title",
                      {
                        "selected-section":
                          _vm.$store.getters.isFieldSelected("offers") ||
                          _vm.$store.getters.getGlobalSearchResult("offers")
                            .length === 0
                      }
                    ],
                    on: {
                      click: function($event) {
                        _vm.openResultSection(
                          _vm.$t("globalSearchSections.offers"),
                          $event
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("globalSearchSections.offers")) + " "
                    )
                  ]
                )
              : _vm._e()
          ]
        )
      : _vm._e(),
    _c(
      "div",
      {
        staticClass: "search-dropdown-content search-section-content-container"
      },
      [
        _c("GlobalSearchSingleResult", {
          attrs: {
            id: _vm.$t("globalSearchSections.stories"),
            stories: _vm.$store.getters.getGlobalSearchResult("projectsByText"),
            matchedFilters: [],
            hideByDefault: false,
            isTitleAndMatchTextCombined: false
          }
        }),
        _c("GlobalSearchSingleResult", {
          attrs: {
            id: _vm.$t("globalSearchSections.tools"),
            stories: _vm.$store.getters.getGlobalSearchResult("projectsByTool"),
            matchedFilters: _vm.getFilters("tools"),
            filterType: "tools",
            hideByDefault: _vm.$store.getters.hideByDefault
          }
        }),
        _c("GlobalSearchSingleResult", {
          attrs: {
            id: _vm.$t("globalSearchSections.certifications"),
            stories: _vm.$store.getters.getGlobalSearchResult(
              "projectsByCertification"
            ),
            matchedFilters: _vm.getFilters("certifications"),
            filterType: "certifications",
            hideByDefault: _vm.$store.getters.hideByDefault
          }
        }),
        !_vm.$store.getters.getGlobalSearchResult("showResults")
          ? _c("GlobalSearchSingleResult", {
              attrs: {
                id: _vm.$t("globalSearchSections.top5Projects"),
                stories: _vm.top5Projects,
                matchedFilters: [],
                showNumberOfProjects: 5,
                hideByDefault: false,
                hideShowAllButton: true,
                isTitleAndMatchTextCombined: false
              }
            })
          : _vm._e(),
        _c("GlobalSearchSingleResult", {
          attrs: {
            id: _vm.$t("globalSearchSections.companies"),
            stories: _vm.$store.getters.getGlobalSearchResult(
              "projectsByCompany"
            ),
            matchedFilters: _vm.getFilters("companies"),
            filterType: "companies",
            hideByDefault: _vm.$store.getters.hideByDefault
          }
        }),
        _c("GlobalSearchSingleResult", {
          attrs: {
            id: _vm.$t("globalSearchSections.referenceOwners"),
            stories: _vm.$store.getters.getGlobalSearchResult(
              "projectsByOwner"
            ),
            matchedFilters: _vm.getFilters("referenceOwners"),
            filterType: "referenceOwners",
            hideByDefault: _vm.$store.getters.hideByDefault
          }
        }),
        _c("GlobalSearchSingleResult", {
          attrs: {
            id: _vm.$t("globalSearchSections.businessContactManagers"),
            stories: _vm.$store.getters.getGlobalSearchResult(
              "projectsByBusinessContactManager"
            ),
            matchedFilters: _vm.getFilters("businessContactManagers"),
            filterType: "businessContactManagers",
            hideByDefault: _vm.$store.getters.hideByDefault
          }
        }),
        _c("GlobalSearchSingleResult", {
          attrs: {
            id: _vm.$t("globalSearchSections.deliveryContactManagers"),
            stories: _vm.$store.getters.getGlobalSearchResult(
              "projectsByDeliveryContactManager"
            ),
            matchedFilters: _vm.getFilters("deliveryContactManagers"),
            filterType: "deliveryContactManagers",
            hideByDefault: _vm.$store.getters.hideByDefault
          }
        }),
        _c("GlobalSearchSingleOfferResult", {
          attrs: {
            id: _vm.$t("globalSearchSections.offers"),
            offers: _vm.$store.getters.getGlobalSearchResult("offers"),
            hideByDefault: _vm.$store.getters.hideByDefault,
            isTitleAndMatchTextCombined: true
          }
        }),
        _vm.getResultLength === 0 &&
        _vm.$store.getters.getGlobalSearchResult("word") !== ""
          ? _c("div", { staticClass: "no-results-from-global-search" }, [
              _vm._v(" " + _vm._s(_vm.$t("globalSearchSections.noMatch")) + " ")
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }